import { capitalize } from '@material-ui/core/utils';
import dayjs from 'dayjs';
/** Generates monthly periods (e.g. July 2020, June 2020 etc)
that a user can choose from within a <Select> component */
export default function generatePeriodStages({
  months,
  useUtc
}) {
  const periodArray = [];
  const now = useUtc ? dayjs.utc() : dayjs();

  // Typescript doesn't like loops.
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i < months; i++) {
    const month = now.subtract(i, 'months');
    const monthString = month.format('MMMM YYYY');
    const capitalizeMonthString = capitalize(monthString);
    const dateFrom = now.subtract(i, 'months').startOf('month');
    const dateTo = now.subtract(i, 'months').endOf('month');
    const periodObject = {
      label: capitalizeMonthString,
      value: `timespan${i}`,
      dateFrom,
      dateTo
    };
    periodArray.push(periodObject);
  }
  return periodArray;
}